export default __webpack_public_path__ + "static/media/Group1105.0e4e0857.svg";